let currencySymbolGlobal = '';

setTimeout(function() {
	getCurrencySymbol('.js-get-symbol');
}, 1000);

createCartPopup($('.js-cart'), $('.js-cart-container'));

$(document).on('click', '.js-quantity-container .quantity__controls', function() {
	const $this = $(this);
	const qtyInput = $this.parent().find('.js-total-quantity');
	const qtyInputLine = qtyInput.data('line');
	const itemPrice = qtyInput.data('price');
	const qtyInputId = qtyInput.data('vid');
	const maxItems = qtyInput.attr('max');

	let qtyInputVal = qtyInput.val();
	qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

	if ($this.hasClass('js-plus-quantity')) {
		qtyInputVal++;
		qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
	} else {
		qtyInputVal--;
		qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
	}

	if (qtyInputVal > maxItems) {
		qtyInputVal = maxItems;
		return;
	}

	if (qtyInputVal <= 0) {
		qtyInputVal = 1;
		qtyInput.val(qtyInputVal);
		return;
	}

	qtyInput.val(qtyInputVal);
	changeProductQuantity($this, qtyInputVal, qtyInputLine, $('.js-cart-container'));

	// this is for the main cart quantity
	if ($this.hasClass('js-cart-controls')) {
		cartPageQuantity(qtyInputId, qtyInputVal, $this);
	}
});

$(document).on('change', '.js-total-quantity', function() {
	const $this = $(this);
	let qtyInputVal = parseInt($this.val());
	let qtyInputLine = $this.data('line');
	const qtyInputId = $this.data('vid');
	const itemPrice = $this.data('price');
	const maxItems = parseInt($this.attr('max'));

	if (qtyInputVal > maxItems) {
		qtyInputVal = maxItems;
		$this.val(maxItems);
	}

	if (qtyInputVal <= 0) {
		qtyInputVal = 1;
		$this.val(1);
	}

	changeProductQuantity($this, qtyInputVal, qtyInputLine, $('.js-cart-container'));
	// this is for the main cart quantity
	if ($this.hasClass('js-total-main-quantity')) {
		cartPageQuantity(qtyInputId, qtyInputVal, $this);
	}
});

// activate checkout button
$(document).on('click', '.js-checkout-toggle', function() {
	$('.js-checkout').trigger('click');
});

// remove Button Ajaax
$(document).on('click', '.js-ajax-remove', function(e) {
	e.preventDefault();
	const $this = $(this);
	const href = $this.attr('href');

	$.ajax({
		url: href,
		beforeSend: function beforeSend() {
			$this.parents('.widget__item').slideUp();
			$('.js-cart-widget').addClass('loads');
		},
		complete: function complete() {
			$('.js-cart-widget').removeClass('loads');
		}
	}).done(function(data) {
		populateCartPopup($('.js-cart-container'), data);
	});
});

// Create Cart Popup
function createCartPopup($link, $cartPopupContent) {
	let href = $link.attr('href');

	getCurrencySymbol('.js-get-symbol');

	$(document).on('submit', '.js-product-form', function(event) {
		event.preventDefault();

		$.ajax({
			url: '/cart/add',
			data: $(this).serialize(),
			type: 'POST'
		})
			.done(function(data) {
				populateCartPopup($cartPopupContent, data);

				$('.wrapper').addClass('expand-cart');
			})
			.fail(function(data) {
				alert('There are no more available products from this option.');
			});
	});

	$.ajax({
		url: href,
		type: 'GET'
	}).done(function(data) {
		$cartPopupContent.html(
			$(data)
				.find('.js-cart-popup-get')
				.html()
		);
	});
}

// populate Cart Popup
function populateCartPopup($cartPopupContent, data) {
	const $cartTextLink = $('.js-cart-counter');
	const currentCurrency = $('body').data('current');

	let cartTextNew = $(data)
		.find('.item-counter')
		.text();

	$cartTextLink.text(cartTextNew);

	let count = parseInt(cartTextNew);

	if (count <= 0) {
		$cartTextLink.addClass('hidden');
	} else {
		$cartTextLink.removeClass('hidden');
	}

	$cartPopupContent.html(
		$(data)
			.find('.js-cart-popup-get')
			.html()
	);
	if ($('.sca-body-currency').length && currentCurrency !== 'GBP') {
		$cartPopupContent.find('.js-widget-item').each(function() {
			const $this = $(this);
			secomappFixAjaxCart($this, currentCurrency);
		});
		secomappFixAjaxCart($('.js-widget-total'), currentCurrency);
	}
}

// handle Popup Cart Quantity
function changeProductQuantity(current, increaseNumber, selectLine, $cartPopupContent) {
	$.ajax({
		url: '/cart/change?line='.concat(selectLine, '&amp;quantity=').concat(increaseNumber),
		beforeSend: function beforeSend() {
			if (increaseNumber <= 0) {
				current.parents('.widget__item').slideUp();
			}

			$('.js-cart-widget').addClass('loads');
		},
		complete: function complete() {
			$('.js-cart-widget').removeClass('loads');
		}
	}).done(function(data) {
		populateCartPopup($cartPopupContent, data);
	});
}

function cartPageQuantity(variant_id, quantity, $current) {
	const currentCurrency = $('body').data('current');
	const regex = /^[^0-9]*/gi;
	const currencySymbol = $('.js-total')
		.text()
		.match(regex);

	$.ajax({
		url: '/cart/change.js',
		type: 'POST',
		data: 'quantity=' + quantity + '&id=' + variant_id,
		dataType: 'json'
	})
		.done(function(data) {
			const shopCurrency = data.currency;
			const removeZeroes = /.00$/gi;
			let currentItemPrice = 0;
			let currentItemPriceConverted = '';
			let totalPrice = 0;
			let formatTotalPrice = '';

			if ($('.sca-body-currency').length) {
				totalPrice = Currency.convert(data.total_price, shopCurrency, currentCurrency);
			} else {
				totalPrice = data.total_price;
			}
			formatTotalPrice = floatToString(totalPrice / 100.0, 2)
				.replace(/\./, '.')
				.replace(/(\d+)(\d{3}[\.,]?)/, '$1,$2');

			data.items.forEach(function(item) {
				if (item.variant_id === variant_id) {
					if ($('.sca-body-currency').length) {
						currentItemPrice = Currency.convert(item.final_line_price, shopCurrency, currentCurrency);
					} else {
						currentItemPrice = item.final_line_price;
					}
					currentItemPriceConverted = floatToString(currentItemPrice / 100.0, 2)
						.replace(/\./, '.')
						.replace(/(\d+)(\d{3}[\.,]?)/, '$1,$2');
				}
			});

			if (currentCurrency === shopCurrency || shopCurrency === 'GBP') {
				currentItemPriceConverted = currentItemPriceConverted.replace(removeZeroes, '');
				formatTotalPrice = formatTotalPrice.replace(removeZeroes, '');
			}

			$current
				.parents('tr')
				.find('.js-item-total')
				.text(currencySymbol + currentItemPriceConverted);
			$('.js-total').text(currencySymbol + formatTotalPrice);

			if (quantity === 0) {
				$current.parents('tr').hide();
			}
		})
		.fail(function() {});
}

function floatToString(itemTotal, decimal) {
	let test = itemTotal.toFixed(decimal);
	return test;
}

function secomappFixAjaxCart($this, currentCurrency) {
	const regex = /^[^0-9]*/gi;
	let getText = $this.text();
	let stripText = getText
		.replace(regex, '')
		.replace(',', '')
		.replace('.', '')
		.concat('00');
	let price = Currency.convert(stripText, 'GBP', currentCurrency);
	let formatPrice = floatToString(price / 100.0, 2)
		.replace(/\./, '.')
		.replace(/(\d+)(\d{3}[\.,]?)/, '$1,$2');
	return $this.html(currencySymbolGlobal + formatPrice);
}

function getCurrencySymbol(container) {
	currencySymbolGlobal = $(container)
		.text()
		.split('0')[0];
}
